
import React, { useState, MouseEvent } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField,
    Popover
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel} from '../../models/models';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';
import {UrlQRCodePreview} from './UrlField';

export const ProcedureFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: string,
}> = ( {
  layoutField,
  value
}) => {

  /* FOR NOW: SIMPLY USE A TEXT FIELD, BUT CHANGE THIS IN FUTURE
  IMPLEMENTED ALREADY:
  - URLField
  */

  /*********QRCODE ELEMENT**************/

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handlePreviewEnter = (e: MouseEvent<HTMLElement>) => {
    //for now, only set anchor element when image
    const target = e.target as HTMLElement;
    if (target.closest('button')) {
      setAnchorEl(null)
      return; // ignore hover over any button/icon
    }

    if(value){
      setAnchorEl(e.currentTarget);
    }
  };
  const handlePreviewLeave = () => setAnchorEl(null);

  /****************************/

  const getUrl = (url: string | null | undefined) => {
    if(url === null || url === undefined) return '';
    if(url.startsWith('http://')) return url;
    if(url.startsWith('https://')) return url;
    return `https://${url}`;
  }



  switch(layoutField.ReferencedField_sys.ReturnType_sys){
    case 'URLField':
      return (
        <Box
          onMouseLeave={handlePreviewLeave}
          onMouseEnter={handlePreviewEnter}
          sx={{
            display: 'inline-block',
            width: '100%'
          }}
        >
          <TextField
            fullWidth
            error={false}
            disabled={true}
            required={false}
            size="small"
            label={`${layoutField.ReferencedField_sys.Label_sys}`}
            variant="filled"
            value={value}
            onChange={() => {}}
            helperText={layoutField.ReferencedField_sys.HelpText_sys}
            InputProps={{
              endAdornment: (
                 <InputAdornment position="end">
                    <IconButton
                       disabled = {value === undefined || value == null || value === ""}
                       component="a"
                       size="small"
                       target="_blank"
                       href={getUrl(value)}
                       >
                    <OpenInNewIcon />
                   </IconButton>
               </InputAdornment>
              )
            }}
          />
          <Popover
            sx={{ pointerEvents: 'none' }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            onClose={handlePreviewLeave}
            disableRestoreFocus
            disableScrollLock
          >
            {
              value &&
              <UrlQRCodePreview
                url={getUrl(value)}
              />
            }

          </Popover>
        </Box>
      )
    default:
      return (
        <TextField
          fullWidth
          error={false}
          disabled={true}
          required={false}
          size="small"
          label={layoutField.ReferencedField_sys.Label_sys}
          variant="filled"
          value={value}
          onChange={() => {}}
          helperText={layoutField.ReferencedField_sys.HelpText_sys}
        />
      )
  }

};
